import { ClientJson } from '../../types/models';
import { CamionNetBaseApiClient } from '../base-client';

/**
 * Client API Types
 */
export type GetClientsResponse = ClientJson[];
export type GetClientByIdResponse = ClientJson;
export type GetRecentClientsResponse = ClientJson[];

/**
 * Client API Endpoints
 */
export class ClientsApi extends CamionNetBaseApiClient {
  /**
   * Get all clients
   */
  async getClients(): Promise<GetClientsResponse> {
    return this.request<GetClientsResponse>('/api2/clients');
  }

  /**
   * Get client by ID
   */
  async getClientById(clientId: number): Promise<GetClientByIdResponse> {
    return this.request<GetClientByIdResponse>(`/api2/clients/${clientId}`);
  }

  /**
   * Get recent clients
   */
  async getRecentClients(): Promise<GetRecentClientsResponse> {
    return this.request<GetRecentClientsResponse>('/api2/clients/recent');
  }
}
